import React from 'react';
import st from './style.module.css';

// calendar.app.google short link sends X-Frame-Options: SAMEORIGIN, so the iframe uses the final embeddable URL
const EMBED_URL =
  'https://calendar.google.com/calendar/appointments/schedules/AcZssZ0gnJj0m0gUx3II2hGqkQJER1Pc22jyohKKE5druAtamd8UrRXmPwz-xs6KQFol_WoCG8bTm2XJ?gv=true&hl=en';

const SchedulaACall = props => {
  return (
    <>
      {props.country == 'BD' || props.country == 'IN' || props.country == 'India' ? (
        <></>
      ) : (
        <div className={st['bg-image'] + ' h-980 ' + st['md:h-580'] + '  md:h-580 relative flex flex-wrap'}>
          <div
            className={
              'h-auto md:h-full ' + st['md:h-full'] + ' relative justify-around px-20 hidden md:flex fix-elem  w-full  lg:w-60p bg-center bg-cover'
            }
          >
            <div
              className={
                'w-500 ' +
                st['w-500'] +
                ' pl-20  md:pl-190 ' +
                st['md:pl-190'] +
                ' text-white    relative  h-full   flex flex-col justify-start pt-40 items-start'
              }
            >
              <div className={st['absolute-mobile'] + ' absolute   left-100'}>
                <div
                  className={
                    st['big-text-green'] + ' font-800  text-green text-30   md:text-72  uppercase leading-37 md:leading-88 pr-20 mt-20 md:mt-0 '
                  }
                >
                  Schedule a call
                </div>
                <div className={st['small-text'] + ' capitalize font-normal  text-24 text-left leading-29 text-29 mt-10 pr-20'}>
                  with our account managers
                </div>
              </div>
            </div>
            <div className={st['img-container'] + ' relative self-end w-full'}>
              <img
                width={554}
                height={505}
                src="/images/dif/Nare.webp"
                className={st['z-100'] + ' hide  ' + st['circle-image']}
                alt={'personage  lusi'}
              />

              <div
                className={st.phone + ' hidden md:flex absolute bottom-100 w-57 h-57 left-95'}
                style={{ backgroundImage: `url(/images/smm/phone.svg)` }}
              >
                <div className={st.vector1 + ' w-8 h-8 absolute top-20 left-30'} style={{ backgroundImage: `url(/images/smm/vector1.png)` }} />
                <div className={st.vector2 + ' w-14 h-14 absolute top-12 left-32'} style={{ backgroundImage: `url(/images/smm/vector2.png)` }} />
                <div className={st.vector3 + ' w-20 h-20 absolute top-0 left-36'} style={{ backgroundImage: `url(/images/smm/vector3.png)` }} />
              </div>
            </div>
          </div>
          <div className="flex md:hidden px-20 py-20 w-full justify-end">
            <div className={st['text-part'] + ' left-20  absolute w-300'}>
              <div
                className={
                  st['big-text-green'] + ' font-800  text-green text-30   md:text-72  uppercase leading-37 md:leading-88 pr-20 mt-20 md:mt-0 '
                }
              >
                Schedule a call
              </div>

              <div className={st['small-text'] + ' capitalize font-normal text-white  text-16 md:text-24 text-left leading-29 text-29 mt-10 pr-20'}>
                with our account managers
              </div>
            </div>
            <div className={'mt-20'}>
              <img
                width={200}
                src="/images/dif/nare_mob.webp"
                className={st['z-100'] + ' hide  hide  float-right w-full ' + st['circle-image']}
                alt={'personage  lusi'}
              />
            </div>
          </div>
          <div className={'h-auto ' + st['md:h-full'] + ' w-full lg:w-40p  flex justify-center items-center mt-20 md:mt-40 md:mt-0 pb-40'}>
            <div className="calendly-inline-widget flex  justify-start items-center min-w-320 md:min-w-500 w-80p  " data-url={EMBED_URL}>
              <iframe
                title={'calendly'}
                src={EMBED_URL}
                width={props.width < 1024 ? '100%' : '361px'}
                height={'500px'}
                className={st['z-100']}
                style={{ backgroundColor: '#fff', borderRadius: 12 }}
                frameBorder={0}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default SchedulaACall;
